/**
 * WOM overall_company ratings for collection/home product cards.
 * API: https://api.thewordofmouth.in/api/overall_company/conscious_chemist
 *
 * - Star ratings: overall_rating + total_reviews
 * - Marketplace carousel: external_ratings (amazon, flipkart, myntra, nykaa, blinkit, zepto)
 * - Hides marketplace badge when product has no external_ratings
 */
(function () {
  'use strict';

  var STATE_KEY = '__womCollectionRatings_cc';
  var API_URL = 'https://api.thewordofmouth.in/api/overall_company/conscious_chemist';
  var CACHE_KEY = 'wom_overall_company_conscious_chemist_v1';
  var CACHE_TTL_MS = 10 * 60 * 1000;

  var PERF = window.WOMPerf || { mark: function () {}, span: function () { return function () {}; } };
  var PLATFORM_ORDER = ['amazon', 'flipkart', 'myntra', 'nykaa', 'blinkit', 'zepto'];
  var PLATFORM_LOGOS = {
    amazon: 'https://techdocs.akamai.com/identity-cloud/img/social-login/identity-providers/amazon-logo.png',
    flipkart: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxggIt5CPQqUxKi3eW4QhNIKv5eH5LdhRwMA&s',
    myntra:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.myntra) ||
      'https://i.pinimg.com/736x/10/8f/fd/108ffd534d2076aa59babdb3b925438d.jpg',
    nykaa:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.nykaa) ||
      'https://companieslogo.com/img/orig/NYKAA.NS-d90b04ce.png?t=1752557278',
    blinkit:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.blinkit) ||
      'https://images.yourstory.com/cs/2/f86c090087cc11eba777b34f5b721f5e/NewPhoto-BlinkIt-1656076381781.png?mode=crop&crop=faces&ar=2%3A1&format=png&w=512&q=90',
    zepto:
      (window.WOM_MP_LOGOS && window.WOM_MP_LOGOS.zepto) ||
      'https://play-lh.googleusercontent.com/2fkLe1316HzNbotEM69s_veNo-fQFVL0v8A9t_eUgfqRX0i2-bNL_G4pzwL7qurTRWi8C3UXwxeWWpuT9UlT4A=w240-h480-rw',
  };
  var PLATFORM_LABELS = {
    amazon: 'Amazon',
    flipkart: 'Flipkart',
    myntra: 'Myntra',
    nykaa: 'Nykaa',
    blinkit: 'Blinkit',
    zepto: 'Zepto',
  };

  var INTERVAL_MS = 3400;
  var DURATION_MS = 450;
  var EASE_EXIT = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var EASE_ENTER = 'cubic-bezier(0.22, 1, 0.36, 1)';

  var STAR_SVG =
    '<svg class="pcmp-rating__star" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#f97316"/>' +
    '</svg>';

  if (window[STATE_KEY] && window[STATE_KEY].bootstrapped) return;
  window[STATE_KEY] = window[STATE_KEY] || { data: null, fetching: false, bootstrapped: true };
  var state = window[STATE_KEY];

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || !parsed.data) return null;
      if (Date.now() - parsed.t > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;');
  }

  function formatMarketplaceCount(n) {
    var num = Number(String(n).replace(/[^\d.]/g, '')) || 0;
    if (num >= 100000) return Math.round(num / 1000) + 'K+';
    if (num >= 10000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
    if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
    return String(num);
  }

  function formatCardReviewCount(n) {
    var num = Number(String(n).replace(/[^\d.]/g, '')) || 0;
    if (num >= 100000) return Math.round(num / 1000) + 'K+';
    if (num >= 10000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
    if (num > 0 && num < 10) return String(num);

    var decadeFloor = Math.floor(num / 10) * 10;
    var diffFromDecade = num - decadeFloor;

    if (diffFromDecade > 0 && diffFromDecade <= 9 && decadeFloor >= 10) {
      return decadeFloor + '+';
    }

    if (num === 10) return '10';

    var delta = 5 + (num % 6);
    var bucket = Math.floor((num - delta) / 10) * 10;
    if (bucket < 10) return String(num);
    return bucket + '+';
  }

  function resolvePayload(el) {
    if (!state.data) return null;
    var handle = (el.getAttribute('data-product-handle') || '').toLowerCase();
    if (!handle) return null;

    if (window.WOMHandleResolver && window.WOMHandleResolver.lookupInCompanyData) {
      var match = window.WOMHandleResolver.lookupInCompanyData(state.data, handle);
      if (match) return match.data;
    }

    if (state.data[handle]) return state.data[handle];

    var variants = [handle, handle.replace(/-/g, '_'), handle.replace(/_/g, '-')];
    for (var i = 0; i < variants.length; i++) {
      if (state.data[variants[i]]) return state.data[variants[i]];
    }
    return null;
  }

  function starSvg(filled) {
    var fill = filled ? '#FDB022' : '#D0D5DD';
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="' +
      fill +
      '" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'
    );
  }

  function halfStarSvg() {
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="none">' +
      '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#D0D5DD"/>' +
      '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#FDB022" style="clip-path: inset(0 50% 0 0);"/>' +
      '</svg>'
    );
  }

  function buildStars(rating) {
    var score = Math.round(Number(rating) * 2) / 2;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (score >= i) html += starSvg(true);
      else if (score >= i - 0.5) html += halfStarSvg();
      else html += starSvg(false);
    }
    return html;
  }

  /**
   * Some products ship overall_rating=0 while still having marketplace
   * external_ratings + total_reviews. Average those platform ratings so the
   * card star row can render instead of staying hidden.
   */
  function fallbackRatingFromExternal(external) {
    if (!external || typeof external !== 'object') return 0;
    var sum = 0;
    var n = 0;
    Object.keys(external).forEach(function (key) {
      var item = external[key];
      if (!item) return;
      var rating = Number(item.rating);
      if (!rating || rating <= 0) return;
      sum += rating;
      n += 1;
    });
    return n ? sum / n : 0;
  }

  function fallbackCountFromExternal(external) {
    if (!external || typeof external !== 'object') return 0;
    var sum = 0;
    Object.keys(external).forEach(function (key) {
      var item = external[key];
      if (!item) return;
      var count = Number(String(item.review_count || '').replace(/[^\d.]/g, '')) || 0;
      sum += count;
    });
    return sum;
  }

  function applyStarRating(el) {
    if (!el || el.getAttribute('data-wom-processed') === '1') return;

    var payload = resolvePayload(el);
    var rating = payload ? Number(payload.overall_rating) || 0 : 0;
    var total = payload ? Number(payload.total_reviews) || 0 : 0;
    var external = payload && payload.external_ratings;

    // API often returns overall_rating=0 for popular SKUs that still have
    // marketplace ratings — fall back so the star row matches the badge data.
    if (rating <= 0 && external) {
      rating = fallbackRatingFromExternal(external);
    }
    if (total <= 0 && external) {
      total = fallbackCountFromExternal(external);
    }

    el.setAttribute('data-wom-processed', '1');

    if (rating <= 0 || total <= 0) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.classList.remove('is-ready');
      return;
    }

    var scoreEl = el.querySelector('.wom-rating-number');
    var starsEl = el.querySelector('.wom-rating-stars');
    var countEl = el.querySelector('.wom-rating-count');

    if (scoreEl) scoreEl.textContent = rating.toFixed(1);
    if (starsEl) starsEl.innerHTML = buildStars(rating);
    if (countEl) countEl.textContent = '(' + formatCardReviewCount(total) + ')';

    el.hidden = false;
    el.removeAttribute('aria-hidden');
    el.classList.add('is-ready');
  }

  function logoClass(key) {
    if (key === 'myntra' || key === 'flipkart' || key === 'nykaa' || key === 'blinkit' || key === 'zepto') {
      return 'pcmp-rating__logo pcmp-rating__logo--' + key;
    }
    return 'pcmp-rating__logo';
  }

  function badgesFromExternal(external) {
    if (!external || typeof external !== 'object') return [];
    var badges = [];
    PLATFORM_ORDER.forEach(function (key) {
      var item = external[key];
      if (!item) return;
      var rating = Number(item.rating);
      if (!rating || rating <= 0) return;
      badges.push({
        key: key,
        label: PLATFORM_LABELS[key] || key,
        rating: rating.toFixed(1),
        count: formatMarketplaceCount(item.review_count),
        logo: PLATFORM_LOGOS[key],
      });
    });
    return badges;
  }

  function renderMarketplaceBadge(badge) {
    return (
      '<img class="' +
      logoClass(badge.key) +
      '" src="' +
      escapeAttr(badge.logo) +
      '" alt="' +
      escapeAttr(badge.label) +
      '" loading="lazy">' +
      STAR_SVG +
      '<span class="pcmp-rating__score">' +
      escapeHtml(badge.rating) +
      '</span>' +
      '<span class="pcmp-rating__count">(' +
      escapeHtml(badge.count) +
      ')</span>'
    );
  }

  function setPhase(el, phase) {
    el.classList.remove('is-idle', 'is-exit', 'is-enter');
    el.classList.add('is-' + phase);
  }

  function setTransition(el, easing) {
    el.style.transition =
      'transform ' +
      DURATION_MS +
      'ms ' +
      easing +
      ', opacity ' +
      Math.round(DURATION_MS * 0.9) +
      'ms ' +
      easing;
  }

  function clearTransition(el) {
    el.style.transition = 'none';
  }

  function waitTransition(el) {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.removeEventListener('transitionend', onEnd);
        resolve();
      }
      function onEnd(e) {
        if (e.target === el && (e.propertyName === 'transform' || e.propertyName === 'opacity')) {
          finish();
        }
      }
      el.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, DURATION_MS + 80);
    });
  }

  function initMarketplaceCarousel(root, badges) {
    if (!root || root.getAttribute('data-pcmp-init') === '1') return;
    var el = root.querySelector('[data-pcmp-badge]');
    if (!el || !badges.length) return;

    root.setAttribute('data-pcmp-init', '1');
    root.hidden = false;
    root.removeAttribute('aria-hidden');
    root.setAttribute('aria-label', 'Marketplace ratings');

    var idx = 0;
    var cycling = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    clearTransition(el);
    el.innerHTML = renderMarketplaceBadge(badges[0]);
    el.setAttribute('aria-label', badges[0].label + ' rating');
    setPhase(el, 'idle');

    if (badges.length < 2 || reducedMotion) return;

    window.setInterval(function () {
      if (cycling) return;
      cycling = true;
      setTransition(el, EASE_EXIT);
      setPhase(el, 'exit');

      waitTransition(el)
        .then(function () {
          idx = (idx + 1) % badges.length;
          clearTransition(el);
          el.innerHTML = renderMarketplaceBadge(badges[idx]);
          el.setAttribute('aria-label', badges[idx].label + ' rating');
          setPhase(el, 'enter');
          el.offsetHeight;
          setTransition(el, EASE_ENTER);
          window.requestAnimationFrame(function () {
            setPhase(el, 'idle');
          });
          return waitTransition(el);
        })
        .then(function () {
          clearTransition(el);
          cycling = false;
        });
    }, INTERVAL_MS);
  }

  function applyMarketplace(root) {
    if (!root || root.getAttribute('data-pcmp-init') === '1') return;

    var payload = resolvePayload(root);
    var badges = badgesFromExternal(payload && payload.external_ratings);

    if (!badges.length) {
      root.setAttribute('data-pcmp-init', '1');
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      return;
    }

    initMarketplaceCarousel(root, badges);
  }

  function applyAll() {
    if (!state.data) return;
    document.querySelectorAll('[data-wom-card-rating]:not([data-wom-processed="1"])').forEach(applyStarRating);
    document.querySelectorAll('[data-pcmp-carousel]:not([data-pcmp-init="1"])').forEach(applyMarketplace);
  }

  var applyScheduled = false;
  function scheduleApplyAll() {
    if (applyScheduled) return;
    applyScheduled = true;
    window.requestAnimationFrame(function () {
      applyScheduled = false;
      if (state.data) applyAll();
      else fetchData();
    });
  }

  function nodeHasRatingTargets(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && (node.matches('[data-wom-card-rating]') || node.matches('[data-pcmp-carousel]'))) {
      return true;
    }
    if (!node.querySelector) return false;
    return !!(
      node.querySelector('[data-wom-card-rating]:not([data-wom-processed="1"])') ||
      node.querySelector('[data-pcmp-carousel]:not([data-pcmp-init="1"])')
    );
  }

  function statsForHandle(handle) {
    if (!handle) return null;
    var probe = document.createElement('div');
    probe.setAttribute('data-product-handle', String(handle).toLowerCase());
    var payload = resolvePayload(probe);
    if (!payload) return null;

    var rating = Number(payload.overall_rating) || 0;
    var total = Number(payload.total_reviews) || 0;
    var external = payload.external_ratings;

    if (rating <= 0 && external) rating = fallbackRatingFromExternal(external);
    if (total <= 0 && external) total = fallbackCountFromExternal(external);
    if (rating <= 0 || total <= 0) return null;

    return { rating: rating, total: total };
  }

  function buildVideoRatingHtml(rating, total) {
    return (
      '<span class="wom-video-product-rating__score">' +
      escapeHtml(rating.toFixed(1)) +
      '</span>' +
      '<span class="wom-video-product-rating__stars" aria-hidden="true">' +
      buildStars(rating) +
      '</span>' +
      '<span class="wom-video-product-rating__count">(' +
      escapeHtml(formatCardReviewCount(total)) +
      ')</span>'
    );
  }

  function mountVideoProductRating(container, handle) {
    if (!container) return;

    function apply() {
      var stats = statsForHandle(handle);
      if (!stats) {
        container.innerHTML = '';
        container.hidden = true;
        return;
      }
      container.innerHTML = buildVideoRatingHtml(stats.rating, stats.total);
      container.hidden = false;
      container.setAttribute(
        'aria-label',
        stats.rating.toFixed(1) + ' out of 5 stars, ' + formatCardReviewCount(stats.total) + ' reviews'
      );
    }

    if (!handle) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    if (state.data) {
      apply();
      return;
    }

    if (!state.fetching) fetchData();

    // This rating waits on a 100ms poll rather than on the request itself, so
    // it can only ever appear on a 100ms grid - and gives up after 5s.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (state.data || tries > 50) {
        window.clearInterval(timer);
        apply();
      }
    }, 100);
  }

  window.WomVideoProductRating = {
    mount: mountVideoProductRating,
    statsForHandle: statsForHandle,
  };

  window.WOMCollectionRatings = {
    refresh: scheduleApplyAll,
    applyAll: applyAll,
  };

  function fetchData() {
    if (state.fetching) return;
    state.fetching = true;

    fetch(API_URL, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        state.fetching = false;
        if (!json || typeof json !== 'object') return;
        state.data = json;
        writeCache(json);
        applyAll();
      })
      .catch(function (err) {
        state.fetching = false;
      });
  }

  function boot() {
    var cached = readCache();
    if (cached) {
      state.data = cached;
      applyAll();
    }
    fetchData();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    if (state.data) applyAll();
    else fetchData();
  });

  // featured-collections tabs lazy-load panel HTML via api-button / Section Rendering API
  document.addEventListener('sectionsRenderingAPI:cached', scheduleApplyAll);

  if (typeof MutationObserver !== 'undefined' && document.documentElement) {
    var domObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList' || !mutation.addedNodes.length) continue;
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          if (nodeHasRatingTargets(mutation.addedNodes[j])) {
            scheduleApplyAll();
            return;
          }
        }
      }
    });
    domObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.setInterval(function () {
    if (!state.data) return;
    var pending =
      document.querySelectorAll('[data-wom-card-rating]:not([data-wom-processed="1"])').length +
      document.querySelectorAll('[data-pcmp-carousel]:not([data-pcmp-init="1"])').length;
    if (pending > 0) applyAll();
  }, 2000);
})();
